import { Link } from 'react-router-dom';

export const PatientHeader = ({ id, firstName, lastName, tel, created }) => {
	const faDate = new Date(created.$date).toLocaleDateString('fa-IR');
	return (
		<Link
			id="userdata"
			to={`/patient/${id}`}
			className="grid justify-around w-11/12 grid-cols-2 p-1 mx-auto mb-5 rounded shadow bg-cyan-600 md:py-4 lg:grid-cols-4"
		>
			<span className="text-gray-300">
				<span className="text-white text-bold">نام: </span>
				{firstName}
			</span>
			<span className="text-gray-300">
				<span className="text-white text-bold">نام خانوادگی: </span>
				{lastName}
			</span>
			<span className="text-gray-300">
				<span className="text-white text-bold">تلفن: </span>
				{tel}
			</span>
			<span className="text-gray-300">
				<span className="text-white text-bold">تاریخ: </span>
				{faDate}
			</span>
		</Link>
	);
};
